function getCartComponent() {
  return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
}

function bindDelegatedCreAtcClick() {
  if (bindDelegatedCreAtcClick.bound) return;
  bindDelegatedCreAtcClick.bound = true;

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('cre-product-form .cre-atc-btn');
      if (!button) return;

      const host = button.closest('cre-product-form');
      if (!host || host.classList.contains('hidden')) return;
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      event.preventDefault();
      event.stopPropagation();

      if (typeof host.handleAddToCart === 'function') {
        host.handleAddToCart(event);
        return;
      }

      const form = host.querySelector('form[data-type="add-to-cart-form"]') || host.querySelector('form');
      if (form) {
        form.requestSubmit();
      }
    },
    true
  );
}

if(!customElements.get('cre-product-form')) {
  customElements.define(
    'cre-product-form',
    class CreProductForm extends HTMLElement {
      constructor() {
        super();

        this.productType = (this.getAttribute('data-product-type') || '').toLowerCase();
        this.productVariantId = this.getAttribute('data-vid');
        this.cartUpdateUnsubscriber = undefined;
        this._submitHandler = this.onProductFormSubmit.bind(this);
        this._uiBound = false;
        this._submitting = false;

        this.cacheElements();
        this.bindUIElements();

        console.log('cdebug cre-product-form init...');
      }

      cacheElements() {
        this.productForm = this.querySelector('form[data-type="add-to-cart-form"]') || this.querySelector('form');
        this.addToCartButton = this.querySelector('.cre-atc-btn');
        this.addToCartSpinner = this.querySelector('.loading-overlay__spinner');
        this.sellingPlanSelect = this.querySelector('.selling-plan-options');
        this.cart = getCartComponent();
      }

      bindUIElements() {
        this.cacheElements();

        if (this._uiBound || !this.productForm) return;

        this.productForm.addEventListener('submit', this._submitHandler);
        this._uiBound = true;
      }

      handleAddToCart(event) {
        this.cacheElements();
        return this.onProductFormSubmit({
          preventDefault() {
            if (event && typeof event.preventDefault === 'function') {
              event.preventDefault();
            }
          },
        });
      }

      toggleElementVisibility(show) {
        if(show) {
          this.classList.remove('hidden');
        } else {
          this.classList.add('hidden');
        }
      }

      onCartUpdate(e) {
        const card = this.closest('marmeto-product-card');

        if (e?.source === 'clear-cart') {
          if (card) {
            const cartQtysElem = card.querySelector('.js-variant-cart-qtys');
            if (cartQtysElem) {
              try {
                const qtys = JSON.parse(cartQtysElem.getAttribute('data-qtys') || '{}');
                Object.keys(qtys).forEach((key) => {
                  qtys[key] = 0;
                });
                cartQtysElem.setAttribute('data-qtys', JSON.stringify(qtys));
              } catch (error) {
                cartQtysElem.setAttribute('data-qtys', '{}');
              }
            }
            if (window.syncCartControlVisibility) {
              window.syncCartControlVisibility(card);
              return;
            }
          }
          this.classList.remove('hidden');
          return;
        }

        if (card && window.syncCartControlVisibility) {
          window.syncCartControlVisibility(card);
        }
      }

      connectedCallback() {
        this.productVariantId = this.getAttribute('data-vid');
        this.productType = (this.getAttribute('data-product-type') || '').toLowerCase();
        this.cacheElements();
        this.bindUIElements();

        if (this.cartUpdateUnsubscriber) return;

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          this.onCartUpdate(event);
        });
      }

      disconnectedCallback() {
        if (this.productForm && this._uiBound) {
          this.productForm.removeEventListener('submit', this._submitHandler);
        }

        this._uiBound = false;

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
          this.cartUpdateUnsubscriber = undefined;
        }
      }

      pushDataToKlaviyo() {
        try {
          const categories = this?.getAttribute('data-track-categories').split(',') || [];

          const item = {
            "Name": this?.getAttribute('data-track-name'),
            "ProductID": this?.getAttribute('data-track-id'),
            "Categories": categories,
            "ImageURL": this?.getAttribute('data-track-image-url'),
            "URL": this?.getAttribute('data-track-url'),
            "Brand": this?.getAttribute('data-track-brand'),
            "Price": this?.getAttribute('data-track-price'),
            "Value": this?.getAttribute('data-track-value'),
            "CompareAtPrice": this?.getAttribute('data-track-compare-at-price')
          };

          if(_learnq) {
            _learnq.push(['track', 'Added to Cart', item]);
            console.log('cdebug cre-product-form pushed data to klaviyo', item);
          }

        } catch(e) {
          console.error('cdebug error pushing data to klaviyo', e);
        }
      }


      async onProductFormSubmit(e) {
        e.preventDefault();

        if (this._submitting) return;

        this.cacheElements();

        if (!this.productForm || !this.addToCartButton) return;

        this.cart = getCartComponent();
        if (!this.cart) {
          console.error('cre-product-form: cart drawer/notification not found');
          return;
        }

        this._submitting = true;

        // Show the spinner
        this.addToCartSpinner?.classList.remove('hidden');
        // disable add to cart button
        this.addToCartButton.setAttribute('aria-disabled', true);
        this.addToCartButton.setAttribute('disabled', true);

        // Gather all information to add the product to cart
        const formData = new FormData(this.productForm);

        // const currentSellingPlanDOM = document.querySelector('cart-drawer [data-current-selling-plan]');
        // const currentSellingPlan = currentSellingPlanDOM ? currentSellingPlanDOM.getAttribute('data-current-selling-plan') : 'none';
        // Keep new line items aligned with the currently selected cart frequency.
        const selectedCartFrequencyDOM = document.querySelector(
          'cart-drawer #selling-plan-options input[name="purchase_option"]:checked'
        );
        const currentSellingPlan = selectedCartFrequencyDOM ? selectedCartFrequencyDOM.value : '';
        const defaultSellingPlanId = this.querySelector(`.selling-plan-options`)?.getAttribute('data-default-selling-plan-id');
        /*const productSellingPlanDOM = this.querySelector(`.selling-plan-options [data-selling-plan-name="${currentSellingPlan}"]`);*/
        const normalize = (value) => (value || '').toLowerCase().trim();
        const sellingPlanOptions = Array.from(this.querySelectorAll('.selling-plan-options option'));
        const productSellingPlanDOM = sellingPlanOptions.find(
          (option) => normalize(option?.dataset?.sellingPlanName) === normalize(currentSellingPlan)
        );
        const productSellingPlanId = productSellingPlanDOM ? productSellingPlanDOM.value : defaultSellingPlanId;

        console.log('cdebug currentSellingPlanDOM', currentSellingPlan);

        console.log('cdebug productSellingPlanId', productSellingPlanId);

        // Bundled section rendering - Append to form data sections to be updated after successful add to cart
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);

        // Append to form data line item properties for recharge
        // https://storefront.rechargepayments.com/client/docs/methods/bundle/#getdynamicbundleitems--
        // Rule: Add these information only if product belongs to the dynamic bundle.
        // Drinks and snacks are not included
        if(this.productType == 'meals') {
          if (productSellingPlanId) {
            formData.append('selling_plan', productSellingPlanId);
          }
          formData.append('properties[_rc_bundle]', rc_bundle_id);
          formData.append('properties[_rc_bundle_parent]', rc_bundle_parent);
          formData.append('properties[_rc_bundle_variant]', rc_bundle_variant);
          formData.append('properties[_rc_bundle_collection_id]', rc_bundle_collection_id);
        }
        if(this.productType == 'family meals') {
          if (productSellingPlanId) {
            formData.append('selling_plan', productSellingPlanId);
          }
          formData.append('properties[_rc_bundle]', rc_bundle_id);
          formData.append('properties[_rc_bundle_parent]', rc_bundle_parent);
          formData.append('properties[_rc_bundle_variant]', rc_bundle_variant);
          formData.append('properties[_rc_bundle_collection_id]', rc_bundle_collection_id);
        }
        if(this.productType == 'bundle') {
          if (productSellingPlanId) {
            formData.append('selling_plan', productSellingPlanId);
          }
          formData.append('properties[_rc_bundle]', rc_bundle_id);
          formData.append('properties[_rc_bundle_parent]', rc_bundle_parent);
          formData.append('properties[_rc_bundle_variant]', rc_bundle_variant);
          formData.append('properties[_rc_bundle_collection_id]', rc_bundle_collection_id);
        }
        if(this.productType == 'drinks') {
          if (productSellingPlanId) {
            formData.append('selling_plan', productSellingPlanId);
          }
          formData.append('properties[_rc_bundle]', rc_bundle_id);
          formData.append('properties[_rc_bundle_parent]', rc_bundle_parent);
          formData.append('properties[_rc_bundle_variant]', rc_bundle_variant);
          formData.append('properties[_rc_bundle_collection_id]', rc_bundle_collection_id);
        }
        if(this.productType == 'snacks') {
          if (productSellingPlanId) {
            formData.append('selling_plan', productSellingPlanId);
          }
          formData.append('properties[_rc_bundle]', rc_bundle_id);
          formData.append('properties[_rc_bundle_parent]', rc_bundle_parent);
          formData.append('properties[_rc_bundle_variant]', rc_bundle_variant);
          formData.append('properties[_rc_bundle_collection_id]', rc_bundle_collection_id);
        }

        let response;
        let responseStatus;

        try {
          response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(response => {
            responseStatus = response.status;

            return response.json();
          });

        } catch (e) {
          console.error('cdebug error', e);
          console.log('cdebug error details', e);
        }

        // If response is 200, then successful request
        if(responseStatus == 200) {

          this.pushDataToKlaviyo();

          publish(PUB_SUB_EVENTS.cartUpdate,
                    {
                      source: 'cre-product-form',
                      productVariantId: formData.get('id'),
                      incomingQty: 1,
                      sectionUpdates: response.sections
                    })

          this.cart = getCartComponent() || this.cart;

          try {
            this.cart.renderContents(response, true);
          } catch (renderError) {
            console.error('cre-product-form cart render failed:', renderError);
          }
        } else if (response?.description || response?.message) {
          console.error('cre-product-form add to cart failed:', response.description || response.message);
        }


        this.addToCartButton.removeAttribute('aria-disabled');
        this.addToCartButton.removeAttribute('disabled');
        this.addToCartSpinner?.classList.add('hidden');
        this._submitting = false;

      }
    }
  )
}

bindDelegatedCreAtcClick();

function reinitializeCreCartControls(root) {
  if (!root || !root.querySelectorAll) return;

  root.querySelectorAll('cre-product-form').forEach((form) => {
    form.productVariantId = form.getAttribute('data-vid');
    form.productType = (form.getAttribute('data-product-type') || '').toLowerCase();

    if (typeof form.cacheElements === 'function') {
      form.cacheElements();
    }

    if (!form._uiBound && typeof form.bindUIElements === 'function') {
      form.bindUIElements();
    }
  });

  root.querySelectorAll('cre-quantity-sync').forEach((qty) => {
    qty.productVariantId = qty.getAttribute('data-vid');
    qty.cart = getCartComponent();

    const input = qty.querySelector('input.qty-state');
    qty.productQty = input ? +input.value : +(qty.getAttribute('data-initial-cart-qty') || 0);
  });

  syncCartControlVisibility(root);
}

function syncCartControlVisibility(root) {
  if (!root) return;

  const cards = root.matches?.('marmeto-product-card')
    ? [root]
    : Array.from(root.querySelectorAll?.('marmeto-product-card') || []);

  if (!cards.length && root.querySelector) {
    cards.push(root);
  }

  cards.forEach((card) => {
    const scope = card.matches?.('marmeto-product-card') ? card : card.querySelector?.('marmeto-product-card') || card;
    const creForm = scope.querySelector?.('cre-product-form');
    const creQty = scope.querySelector?.('cre-quantity-sync');
    if (!creForm || !creQty) return;

    const variantId =
      creForm.getAttribute('data-vid') ||
      scope.querySelector('input[name="id"]')?.value ||
      creQty.getAttribute('data-vid');

    if (!variantId) return;

    let qty = 0;
    const cartQtysElem = scope.querySelector?.('.js-variant-cart-qtys');

    if (cartQtysElem) {
      try {
        const qtys = JSON.parse(cartQtysElem.getAttribute('data-qtys') || '{}');
        qty = +(qtys[variantId] || 0);
      } catch (error) {
        qty = 0;
      }
    } else {
      qty = +(creQty.querySelector('input.qty-state')?.value || creQty.getAttribute('data-initial-cart-qty') || 0);
    }

    creForm.setAttribute('data-vid', variantId);
    creQty.setAttribute('data-vid', variantId);
    creForm.productVariantId = variantId;
    creQty.productVariantId = variantId;
    creQty.productQty = qty;

    const input = creQty.querySelector('input.qty-state');
    if (input) input.value = qty;

    if (qty > 0) {
      creForm.classList.add('hidden');
      creQty.classList.remove('hidden');
    } else {
      creForm.classList.remove('hidden');
      creQty.classList.add('hidden');
    }
  });
}

window.reinitializeCreCartControls = reinitializeCreCartControls;
window.syncCartControlVisibility = syncCartControlVisibility;

function cardKnowsVariant(card, variantId) {
  if (!card || !variantId) return false;

  const cartQtysElem = card.querySelector('.js-variant-cart-qtys');
  if (cartQtysElem) {
    try {
      const qtys = JSON.parse(cartQtysElem.getAttribute('data-qtys') || '{}');
      if (Object.prototype.hasOwnProperty.call(qtys, variantId) || Object.prototype.hasOwnProperty.call(qtys, String(variantId))) {
        return true;
      }
    } catch (error) {
      /* ignore parse errors */
    }
  }

  if (card.querySelector(`cre-product-form[data-vid="${variantId}"]`)) return true;
  if (card.querySelector(`cre-quantity-sync[data-vid="${variantId}"]`)) return true;
  if (card.querySelector(`.product-card__variant-swatch[data-variant-id="${variantId}"]`)) return true;
  if (card.querySelector(`.product-card__variant-select option[value="${variantId}"]`)) return true;

  const activeVid =
    card.querySelector('cre-product-form')?.getAttribute('data-vid') ||
    card.querySelector('cre-quantity-sync')?.getAttribute('data-vid');

  return activeVid == variantId;
}

function updateAllCardVariantQtys(event) {
  const isClearCart = event?.source === 'clear-cart';
  const variantId = event?.productVariantId;

  // clear-cart has no variant id — still need to zero every card's qty map
  if (!isClearCart && !variantId) return;

  document.querySelectorAll('marmeto-product-card').forEach((card) => {
    const cartQtysElem = card.querySelector('.js-variant-cart-qtys');

    if (isClearCart) {
      if (cartQtysElem) {
        try {
          const qtys = JSON.parse(cartQtysElem.getAttribute('data-qtys') || '{}');
          Object.keys(qtys).forEach((key) => {
            qtys[key] = 0;
          });
          cartQtysElem.setAttribute('data-qtys', JSON.stringify(qtys));
        } catch (error) {
          console.error('updateAllCardVariantQtys clear failed', error);
          cartQtysElem.setAttribute('data-qtys', '{}');
        }
      }

      const creQty = card.querySelector('cre-quantity-sync');
      if (creQty) {
        creQty.productQty = 0;
        creQty.setAttribute('data-initial-cart-qty', '0');
        const input = creQty.querySelector('input.qty-state');
        if (input) input.value = 0;
      }
      return;
    }

    if (!cartQtysElem) return;

    try {
      const qtys = JSON.parse(cartQtysElem.getAttribute('data-qtys') || '{}');

      if (cardKnowsVariant(card, variantId)) {
        if (event.source === 'cre-product-form') {
          qtys[variantId] = (qtys[variantId] || 0) + (+event.incomingQty || 1);
        } else {
          qtys[variantId] = +event.incomingQty || 0;
        }
      } else {
        return;
      }

      cartQtysElem.setAttribute('data-qtys', JSON.stringify(qtys));
    } catch (error) {
      console.error('updateAllCardVariantQtys failed', error);
    }
  });
}

function syncAllCartControlVisibility() {
  syncCartControlVisibility(document);
}

window.syncAllCartControlVisibility = syncAllCartControlVisibility;

function initGlobalCartControlSync() {
  if (initGlobalCartControlSync.bound) return;
  initGlobalCartControlSync.bound = true;

  syncAllCartControlVisibility();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      updateAllCardVariantQtys(event);
      syncAllCartControlVisibility();
    });
  }

  document.addEventListener('collection:products-loaded', () => {
    setTimeout(syncAllCartControlVisibility, 0);
  });

  let mutationTimer;
  const observer = new MutationObserver((mutations) => {
    const hasNewCards = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === 1 &&
          ((node.matches && node.matches('marmeto-product-card')) ||
            (node.querySelector && node.querySelector('marmeto-product-card')))
      )
    );

    if (!hasNewCards) return;

    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(syncAllCartControlVisibility, 100);
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGlobalCartControlSync);
} else {
  initGlobalCartControlSync();
}



// Requirements:
// https://storefront.rechargepayments.com/client/docs/examples/bundle/dynamic_price_bundle/#the-dynamic-bundle-properties
